// messages.js

export const loadingMessage = "Loading...";
export const saveDraftSuccessMessage = "Your form has been saved as draft successfully!";
export const saveFormSuccessMessage = "Your form has been saved successfully!";
export const saveFormErrorMessage = "Failed to save the form data. Please try again later.";
export const saveLinkErrorMessage = "Failed to save the form link. Please try again later.";
export const saveFormLinkSuccessMessage = "Form link saved successfully!";
export const formClosedMessage = "The form is no longer taking responses.";
export const startDateMissingMessage = "Please provide a start date.";
export const endDateMissingMessage = "Please provide an end date.";
 export const DECRYPT_ID= `${process.env.REACT_APP_API_BASE_URL}/decryptId`;
 export const  DECRYPT_ID_FAIL = 'Failed to decrypt ID';

 export const formTypes = [
  { value: 'open', label: 'Open' },
  { value: 'one-time', label: 'One Time' },
  { value: 'recurring', label: 'Recurring' },
];

export const recurrenceFrequencies = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Biweekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'half-yearly', label: 'Half-Yearly' },
  { value: 'yearly', label: 'Yearly' },
];

export const messages = {
  DECRYPT_ID_FAIL: 'Failed to decrypt ID.',
  saveFormSuccessMessage: 'Form saved successfully!',
  saveFormLinkSuccessMessage: 'Form published successfully!',
  saveFormErrorMessage: 'Failed to save the form data. Please try again later.',
  endDateMissingMessage: 'Please provide both start and end dates.',
  userNotFound: 'User not found.',
  errorDuration: 'Please provide a valid duration (1-30 days).',
  errorFrequency: 'Please select a recurrence frequency.',
};

export const frequencyDays = {
  weekly: 7,
  biweekly: 14,
  monthly: 30,
  quarterly: 90,
  'half-yearly': 180,
  yearly: 365
};